import { render, staticRenderFns } from "./recommendPage2.vue?vue&type=template&id=29c87429&scoped=true&"
import script from "./recommendPage2.vue?vue&type=script&lang=js&"
export * from "./recommendPage2.vue?vue&type=script&lang=js&"
import style0 from "./recommendPage2.vue?vue&type=style&index=0&id=29c87429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c87429",
  null
  
)

export default component.exports